let _ = require("ES/lib/lodash");
let dd = require("ES/lib/dd");
let esUtils = require("ES/utils/esUtils");

module.exports = dd.createClass({
	render(){
		let {sessions} = this.props;
		return dd.div(null,
			_.map(sessions, function(s){

				var bg_color = null;
				if(_.isDate(s.startdate)){
					bg_color = "yellow";
				}
				if(esUtils.getIn(s, ["flags_as_map", "complete", "is_set"])){
					bg_color = "green";
				}
				return dd.div({key: s.id, style: {
					display: "inline-block",
					border: "1px solid black",
					width: ".5em",
					height: "1em",
					marginLeft: ".25em",
					background: bg_color
				}});
			})
		);
	}
});



// WEBPACK FOOTER //
// ./src/components/main_view/event_area/tabs/coaching/StatusBoxes.js